import React, { Component } from 'react'


export default class Disclaimer extends Component {
  render() {
      const {onClick} = this.props;
    return (
        <div>
           
          <h2>Before we get started, it’s important that you understand the following.</h2>
          {/* <h1 >Virtual Dizzy Lab!</h1> */}
          <div className="mt-5">
              
              <p>
                This quiz is intended to be used primarily as a teaching tool to help expedite the diagnostic process. It is not a substitute for medical consultation or treatment by a physician.
              </p>
              <p>
                Dizziness can be caused by many things, most of which are easy to treat, but some causes are more serious and require professional medical attention.
              </p>
              <p>
                In some cases, dizziness may be caused by toxicity, metabolic conditions, or infectious disease. If you believe you or your patient may be at risk for one of these conditions, contact a healthcare provider right away.
              </p>
         
              <button className="btn btn-danger mt-30"  onClick={onClick.bind(this,3,false)}>I understand. Let’s continue!</button>
          </div>
         
        </div>

    )
  }
}
